import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatIdentityCreatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const identityCreated: CaseReducer<NinchatState> = (state, action) => {
    const {
        identity_attrs,
        identity_name,
        identity_type,
        user_id,
        ...rest
    } = extractProperties<NinchatIdentityCreatedEvent>(action.payload)

    isEmpty(rest)

    if (user_id === state.user_id) {
        const ref = state.user_identities[identity_type] ?? {}

        ref[identity_name] = identity_attrs
    }
}
